import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../Layout';
import {
  UserGroupIcon,
  ClipboardDocumentListIcon,
  DocumentTextIcon,
  ChartBarIcon,
  UsersIcon,
} from '@heroicons/react/24/outline';

const CARDS = [
  {
    title: 'Client Maintenance',
    description: 'Add or manage accounting clients and assign in-charge staff.',
    icon: UserGroupIcon,
    path: '/ao/clients',
    color: 'bg-teal-50 border-teal-200 hover:bg-teal-100',
    iconColor: 'text-teal-600',
  },
  {
    title: 'Transaction Entry',
    description: 'Record tax payments, PF, Benefits and processing fees per client per month.',
    icon: ClipboardDocumentListIcon,
    path: '/ao/transactions',
    color: 'bg-blue-50 border-blue-200 hover:bg-blue-100',
    iconColor: 'text-blue-600',
  },
  {
    title: 'Working Paper Report',
    description: 'Full matrix report: clients × tax types × month — for compliance review.',
    icon: DocumentTextIcon,
    path: '/ao/report/working-paper',
    color: 'bg-indigo-50 border-indigo-200 hover:bg-indigo-100',
    iconColor: 'text-indigo-600',
  },
  {
    title: 'Collection Monitor',
    description: 'Track who has paid and who needs collection follow-up.',
    icon: ChartBarIcon,
    path: '/ao/report/collection',
    color: 'bg-amber-50 border-amber-200 hover:bg-amber-100',
    iconColor: 'text-amber-600',
  },
];

const AODashboard = () => {
  const navigate = useNavigate();

  return (
    <Layout pageTitle="Accounting Operations">
      <div className="p-6 max-w-5xl mx-auto">
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-gray-800">Accounting Operations</h2>
          <p className="text-sm text-gray-500 mt-1">
            Internal staff portal for monitoring client tax compliance, collections, and professional fees.
          </p>
        </div>

        {/* Main action cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-8">
          {CARDS.map((card) => {
            const Icon = card.icon;
            return (
              <button
                key={card.path}
                onClick={() => navigate(card.path)}
                className={`flex items-start gap-4 p-5 rounded-xl border text-left transition-colors ${card.color}`}
              >
                <div className={`mt-1 flex-shrink-0 ${card.iconColor}`}>
                  <Icon className="h-7 w-7" />
                </div>
                <div>
                  <p className="font-semibold text-gray-800 text-base">{card.title}</p>
                  <p className="text-xs text-gray-500 mt-1 leading-relaxed">{card.description}</p>
                </div>
              </button>
            );
          })}
        </div>

        {/* Staff Maintenance — small footer link */}
        <div className="border-t border-gray-200 pt-4">
          <button
            onClick={() => navigate('/ao/staff')}
            className="flex items-center gap-2 text-sm text-gray-500 hover:text-teal-600 transition-colors"
          >
            <UsersIcon className="h-4 w-4" />
            <span>Staff / In-Charge Maintenance</span>
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default AODashboard;
